<!-- eslint-disable -->
<template>
  <div :class="P_customClass" :style="C_containerStyle">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <clip-loader 
      v-if="DV_gettingToken"
      :style="C_clipLoaderStyle"
      color="black"
      class="clip_loader" 
      :size="'100px'"
    ></clip-loader>
    <canvas v-show="!DV_gettingToken"  :style="C_canvasStyle" id="qr-canvas"></canvas>
  </div>
</template>

<script>
/* eslint-disable */
import QRCode from 'qrcode'
import AWN from 'awesome-notifications'
import generateControlProcessorToken from '../../watchdog_includes/json_tasks/p1s2/p1s2t4'
import retrieveControlProcessorToken from '../../watchdog_includes/json_tasks/p1s2/p1s2t3'
import verifyControlProcessorToken from '../../watchdog_includes/json_tasks/p1s6/p1s6t10'
import { bi10GridComponent } from '../../watchdog_includes/base_i10_UI_mixins'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  name: 'GQRCodeLogin',
  components: {ClipLoader},
  props: ['P_activeBreakPoint', 'P_size', 'P_logo', 'P_color', 'P_backgroundColor', 'P_borderColor', 'P_paintInnerCornerSquares', 'P_cpUid', 'P_customCss'],
  mixins: [bi10GridComponent],
  data () {
    const CI = this
    return {
      DV_CPAccessToken: null,
      DV_tokenGenerated: false,
      DV_tokenVerificationTime: 1200000, // 20'
      DV_tokenExpirationInterval: null,
      DV_gettingToken: false
    }
  },
  mounted() {
    const CI = this
    CI.retrieveToken()
    CI.DV_tokenExpirationInterval = setInterval(CI.verifyToken, CI.DV_tokenVerificationTime)
  },
  beforeDestroy() {
    const CI = this
    clearInterval(CI.DV_tokenExpirationInterval)
  },
  computed: {
    C_canvasStyle() {
      const CI = this
      const customStyle = {}
      if (CI.P_borderColor) customStyle['border'] = `6px solid ${CI.P_borderColor || '#00549f'}`
      return customStyle
    },
    C_clipLoaderStyle() {
      const CI = this
      const customStyle = {}
      customStyle['border'] = `3px solid ${CI.P_borderColor || '#00549f'}`;
      customStyle['width'] = `${CI.P_size || '300'}px`;
      customStyle['height'] = `${CI.P_size || '300'}px`;
      return customStyle
    },
    C_containerStyle() {
      const CI = this;
      const customStyle = {}
      customStyle['display'] = `flex`;
      customStyle['align-items'] = `center`;
      customStyle['justify-content'] = `center`;
      return customStyle
    }
  },
  methods: {
    retrieveToken() {
      const CI = this
      CI.DV_gettingToken = true;
      const promise = retrieveControlProcessorToken(CI.P_cpUid).then(
        success => {
          CI.verifyToken(success['token'])
        },
        error => {
          console.log(`An error occurred while retrieving the access token: ${JSON.stringify(error)}`)
          if (!CI.DV_tokenGenerated) {
            CI.generateToken()
          } else {
            CI.$awn.warning('An error occurred while retrieving the Login QR code.')
          }
        }
      )
    },
    generateToken() {
      const CI = this
      const promise = generateControlProcessorToken(CI.P_cpUid).then(
        success => {
          CI.DV_tokenGenerated = true
          CI.retrieveToken()
        },
        error => {
          console.log(`An error occurred while generating the access token: ${JSON.stringify(error)}`)
          CI.$awn.warning('An error occurred while generating the Login QR code.')
        }
      )
    },
    verifyToken(token) {
      const CI = this
      const promise = verifyControlProcessorToken(token || CI.DV_CPAccessToken, CI.P_cpUid).then(
        success => {
          console.log(`The access token has passed verification. (ref: ${JSON.stringify(success)})`)
          if (token) { 
            CI.DV_CPAccessToken = token
          } // else nothing to do except wait for next iteration of the interval
          CI.DV_gettingToken = false;
        },
        error => {
          console.log(`The access token has expired, the system will generate a new one. (ref: ${JSON.stringify(error)})`)
          CI.generateToken()
        }
      )
    },
    generateQR() {
      const CI = this
      let options = {
        errorCorrectionLevel: 'H',
        width: CI.P_size || 300,
        color: {
          dark: CI.P_color || '#004c99',
          light: CI.P_backgroundColor || '#FFFFFFFF'
        }
      }
      const messageToCode = `${window.G_p1s6_tasks_domain}/device-interface?token=${CI.DV_CPAccessToken}`
      const canvas =  document.getElementById('qr-canvas');
      QRCode.toCanvas(
        canvas,
        messageToCode,
        options,
        error => {
          if (!error) return

          CI.$awn.warning('An error occurred while creating the Login QR code.')
          console.log(`An error occurred while creating the QR image: ${JSON.stringify(error)}`)
        }
      )

      const ctx = canvas.getContext("2d");
      /// <start> paint custom logo at the center of the canvas
      if (CI.P_logo !== null && CI.P_logo !== undefined && CI.P_logo !== "" ) {
        let center = 0;
        const imageObj = new Image();
        imageObj.src = CI.P_logo;

        if (CI.P_activeBreakPoint == 'sm') {
          center = (CI.P_size - 30) / 2;

          imageObj.onload = function() {
            ctx.drawImage(imageObj, center, center, 30, 30);
          };
        } else {
          center = (CI.P_size - 60) / 2;
          
          imageObj.onload = function() {
            ctx.drawImage(imageObj, center, center, 60, 60);
          };
        }
      }
      /// </end> paint custom logo at the center of the canvas

      /// <start> paint custom squares at three corners
      if (CI.P_paintInnerCornerSquares === '1') {
        // Get all necessary calculations:
          // calculation for blank margin from canvas to actual QR image start
        const marginPX = Math.round(CI.P_size*0.065625)
          // calculation of size of corner squares
        const cornerSquareSizePX = Math.round(CI.P_size*0.115625)
          // calculation for size of inner squares to be painted in the three corners of the QR
        const innerSquareSizePX = Math.round(CI.P_size*0.05)
          // calculation of margin to inner square (from QR image start)
        const squareInnerMarginPX = Math.round(CI.P_size*0.034375)

        ctx.beginPath();
        ctx.fillStyle = '#00549f';
        //draw top left square
        ctx.fillRect(marginPX+squareInnerMarginPX, marginPX+squareInnerMarginPX, innerSquareSizePX, innerSquareSizePX)
        //draw top right square
        ctx.fillRect(CI.P_size-marginPX-cornerSquareSizePX+squareInnerMarginPX, marginPX+squareInnerMarginPX, innerSquareSizePX, innerSquareSizePX)
        //draw bottom left square
        ctx.fillRect(marginPX+squareInnerMarginPX,CI.P_size-marginPX-cornerSquareSizePX+squareInnerMarginPX, innerSquareSizePX, innerSquareSizePX)
      }
      /// </end> paint custom squares at three corners
    }
  },
  watch: {
    DV_CPAccessToken() {
      const CI = this
      CI.generateQR()
    },
    P_size() {
      const CI = this
      CI.generateQR()
    },
    P_color() {
      const CI = this
      CI.generateQR()
    },
    P_backgroundColor() {
      const CI = this
      CI.generateQR()
    },
    P_customCss() {
      const CI = this
      CI.generateQR()
    }
  }
}
</script>

<style>
.clip_loader {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Grid/GQRCodeLogin.vue